var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("filtros", {
        staticClass: "mb-5",
        attrs: {
          model: _vm.dataInputs,
          idOrganization: this.$props.idOrganization,
        },
        on: { filtrar: _vm.onFiltrarClick },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box p-3" },
        [
          _c(
            "b-table",
            {
              attrs: { narrowed: true, data: _vm.auditorias, hoverable: true },
              scopedSlots: _vm._u([
                {
                  key: "empty",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "has-text-centered" }, [
                        _vm._v("~ Sin resultados ~"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("b-table-column", {
                attrs: {
                  field: "created_at",
                  label: "Fecha acción",
                  centered: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              new Date(props.row.created_at).toLocaleString(
                                "en-GB"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("b-table-column", {
                attrs: { field: "user_id", label: "Usuario ID", centered: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(props.row.usuario.id) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("b-table-column", {
                attrs: { field: "user_name", label: "Nombre", centered: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              props.row.usuario.apellido +
                                ", " +
                                props.row.usuario.nombre
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("b-table-column", {
                attrs: { field: "ip", label: "IP Origen", centered: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(
                          "\n            " + _vm._s(props.row.ip) + "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("b-table-column", {
                attrs: { field: "action", label: "Acción", centered: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(props.row.accion) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("b-table-column", {
                attrs: { field: "entity", label: "Entidad", centered: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(props.row.entidad) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("b-table-column", {
                attrs: {
                  field: "entity_id",
                  label: "Entidad ID",
                  centered: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(props.row.objeto_id) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "infinite-loading",
            {
              attrs: { identifier: _vm.identifierLoaderAuditorias },
              on: { infinite: _vm.infiniteHandlerAudits },
            },
            [
              _c(
                "div",
                {
                  staticClass: "py-5 is-size-7 is-family-monospace",
                  attrs: { slot: "no-more" },
                  slot: "no-more",
                },
                [
                  _vm.isLoading
                    ? _c("span", [_vm._v("Cargando...")])
                    : _c("span", [_vm._v("~ Fin del listado ~")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "py-5 is-size-7 is-family-monospace",
                  attrs: { slot: "no-results" },
                  slot: "no-results",
                },
                [_vm.isLoading ? _c("span", [_vm._v("Cargando...")]) : _vm._e()]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box" }, [
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v("Administrar organización"),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [_vm._v("Auditorías")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }